export default {
    SET_USER_INFO: 'setUserInfo',
    REMOVE_USER_INFO: 'removeUserInfo',
    CHECK_USER_INFO: 'checkUserInfo',
    LOGIN: 'login',
    LOGOUT: 'logout',
};
